import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./AnimatedTitle.css";

const AnimatedTitle = () => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 1500), // Phase 1: Split "Hjup"
      setTimeout(() => setPhase(2), 3000), // Phase 2: Insert "ell"
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  const variants = {
    hidden: { opacity: 0, scale: 0.5, x:-5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" }, x:-5 },
  };

  return (
    <div className="title-container">
      {/* Phase 0: Initial "Henriette Nøkleby Hjup" */}
      {phase === 0 && (
        <motion.span
          key={phase} // Forces animation restart when phase changes
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0 }}
          className="word"
        >
          Henriette Nøkleby Hjup
        </motion.span>
      )}

      {/* Phase 1: Split "Hjup" into "Hj" and "up" */}
      {phase === 1 && (
        <>
          <span className="word">Henriette Nøkleby</span>
          <motion.span
            key={phase}
            initial={{ x: 0 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            className="split-letter"
          >
            Hj
          </motion.span>
          <span className="space"></span> {/* Space between "Hj" and "up" */}
          <motion.span
            key={phase}
            initial={{ x: 0 }}
            animate={{ x: 5 }} // Move "up" right
            transition={{ duration: 0.5 }}
            className="split-letter"
          >
            up
          </motion.span>
        </>
      )}

      {/* Phase 2: Insert "ell" between "Hj" and "up" */}
      {phase === 2 && (
        <>
          <span className="word">Henriette Nøkleby</span>
          <motion.span
            key={phase}
            initial={{ x: 0 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            className="split-letter"
          >
            Hj
          </motion.span>
          <motion.span
            key={phase} // Ensures animation starts only when phase is ready
            initial="hidden"
            animate="visible"
            variants={variants}
            className="highlight"
          >
            ell
          </motion.span>
          <motion.span
            key={phase}
            initial={{ x: -10 }}
            animate={{ x: -10 }}
            transition={{ duration: 0.5 }}
            className="split-letter"
          >
            up
          </motion.span>
        </>
      )}
    </div>
  );
};

export default AnimatedTitle;
